/**
 * Image Hover 
 * Author: Ruben Perez 
 */

var ImageHover = (function() {

    var options = {
        articleTextArray: document.querySelectorAll(".js-article-text"),
        imagesArray: document.querySelectorAll(".js-article-image")
    };

    function canInit() {

        if (options.imagesArray.length && options.articleTextArray.length) {
            return true;
        }

        return false;
    }

    function init(params) {

        options = $.extend({}, options, params);

        if (canInit()) {

            for (var i = 0; i < options.articleTextArray.length; i++) {

                // Add id's to article title elements
                var articleText = options.articleTextArray[i];
                var articleId = 'article-text-' + i;
                articleText.setAttribute('id', articleId);

                // Add id's to image elements
                var image = options.imagesArray[i];
                var imageId = 'article-image-' + i;
                image.setAttribute('id', imageId);

            };

            for (var i = 0; i < options.articleTextArray.length; i++) {

                var articleText = options.articleTextArray[i];
                var numberPattern = /\d+/;

                // Add event listener to title elements on hover
                articleText.addEventListener("mouseover", function(e) {

                    // Find id number of element that is currently being hovered
                    var textHovered = e.target;
                    var textHoveredId = textHovered.getAttribute('id');
                    var textHoveredIdNo;

                    if (textHoveredId) {
                        textHoveredIdNo = (textHoveredId.match(numberPattern))[0];
                    }

                    changeImage(textHoveredIdNo);
                });
            }
        }
        console.log('ImageHover initialized');
    }

    function changeImage(id) {

        for (var i = 0; i < options.imagesArray.length; i++) {

            var image = options.imagesArray[i];
            var imageId = '#' + image.getAttribute('id');
            var imageDOM = $(imageId);

            var hoveredImageId = '#article-image-' + id;

            if (imageId == hoveredImageId) {
                imageDOM.addClass('active');
            } else {
                imageDOM.removeClass('active');
            }
        }
    }

    return {
        init: init
    };

})();

$(function() {
    'use strict';
    ImageHover.init();
});